import { surveyLocalization } from 'survey-core';

const customLocaleStrings = {
  pagePrevText: "Anterior",
  pageNextText: "Siguiente",
  completeText: "Enviar"
};

surveyLocalization.locales["customlocale"] = customLocaleStrings;